import { useState } from "react";
import { waitlistApi } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowRight } from "lucide-react";

export default function WaitlistForm({ kicker = "Early access", title = "Get on the list.", note = "First drops, exclusive deals, no spam.", interest = "consumer" }) {
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const r = await waitlistApi.join({ email, city, interest });
      setDone(true);
      toast.success(r.already ? "Already on the list 👌" : "You're in. We'll holler.");
    } catch { toast.error("Something went wrong"); } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="card-x card-green bg-[#15FF73] p-7 text-center">
        <div className="text-5xl bouncy mb-3">🎉</div>
        <h3 className="font-display text-3xl font-extrabold mb-2">You in.</h3>
        <p className="text-sm text-[#0B0F0C]/70">First drop alert lands in your inbox.</p>
      </div>
    );
  }

  return (
    <div className="card-x card-magenta bg-[#FAF6E8] p-7" data-testid="waitlist-card">
      <div className="label-overline text-[#FF1A8C] mb-2">{kicker}</div>
      <h3 className="font-display text-3xl sm:text-4xl font-extrabold leading-tight mb-3 tracking-tight">{title}</h3>
      <p className="text-sm text-[#0B0F0C]/65 mb-5 max-w-md leading-relaxed">{note}</p>
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
        <label className="flex items-center gap-3 rounded-full border-2 border-[#0B0F0C] bg-[#FAF6E8] focus-within:bg-white focus-within:shadow-[3px_3px_0_#0B0F0C] px-4 h-12 transition-all flex-1">
          <Mail size={14} strokeWidth={2.4} />
          <input data-testid="waitlist-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="flex-1 bg-transparent outline-none text-sm placeholder:text-[#0B0F0C]/45 font-medium" />
        </label>
        <input data-testid="waitlist-city" value={city} onChange={(e) => setCity(e.target.value)} placeholder="City (optional)" className="sm:w-32 rounded-full border-2 border-[#0B0F0C] bg-[#FAF6E8] focus:bg-white focus:shadow-[3px_3px_0_#0B0F0C] px-4 h-12 text-sm placeholder:text-[#0B0F0C]/45 outline-none transition-all" />
        <button data-testid="waitlist-submit" type="submit" disabled={busy} className="btn-x btn-primary disabled:opacity-50">{busy ? "..." : <>Join <ArrowRight size={14} strokeWidth={2.4} /></>}</button>
      </form>
    </div>
  );
}
